import { switchMap } from 'rxjs';
import { memo } from '../util/index.js';
/**
 * @description Retrieve the staking overview, including elected and points earned
 */
export function currentPoints(instanceId, api) {
  return memo(instanceId, () => api.derive.session.indexes().pipe(switchMap(_ref => {
    let {
      activeEra
    } = _ref;
    return api.query.staking.erasRewardPoints(activeEra);
  })));
}